<div class="kt-portlet">
    <div class="kt-portlet__head  d-flex align-items-center justify-content-between">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                Yeni Etkinlik Ekle
            </h3>
        </div>
        <button type="button" routerLink="/event-list" class="btn btn-secondary mr-3">Geri Dön</button>
    </div>
    <div class="container" style="width: 90%">
        <form class="kt-form kt-form--label-left" [formGroup]="addEventForm" (ngSubmit)="save()" autocomplete="off">
            <div class="kt-portlet__body">
                
                <div class="form-group">
                    <label class="col-form-label">Etkinlik ismi</label>

                    <input formControlName="name" type="text" class="form-control"
                        placeholder="Etkinlik ismi..">
                    <small class="form-text text-warning"
                        *ngIf="f.name.errors?.required">Lütfen etkinlik ismi giriniz!</small>
                    <small class="form-text text-warning"
                        *ngIf="f.name.errors?.maxlength">Lütfen en fazla 150 haneli bir etkinlik ismi giriniz!</small>
                </div>

                <div class="form-group">
                    <label class="col-form-label">Etkinlik açıklaması</label>

                    <input formControlName="description" type="text" class="form-control"
                        placeholder="Etkinlik açıklaması..">
                    <small class="form-text text-warning"
                        *ngIf="f.description.errors?.required">Lütfen etkinlik açıklaması giriniz!</small>
                    <small class="form-text text-warning"
                        *ngIf="f.description.errors?.maxlength">Lütfen en fazla 300 haneli bir etkinlik açıklaması giriniz!</small>
                </div>

                <div class="form-group">
                    <label class="col-form-label">Etkinlik lokasyonu / Mekan</label>

                    <input formControlName="location" type="text" class="form-control"
                        placeholder="Etkinlik lokasyonu..">
                    <small class="form-text text-warning"
                        *ngIf="f.location.errors?.required">Lütfen etkinlik lokasyonu giriniz!</small>
                    <small class="form-text text-warning"
                        *ngIf="f.location.errors?.maxlength">Lütfen en fazla 250 haneli bir etkinlik lokasyonu giriniz!</small>
                </div>

                <div class="form-group">
                    <label for="status" class="col-form-label">Durum</label>
                    <ng-select name="type" id="status" labelForId="status" bindValue="code"
                        style="width: 100%; padding: 5px; float: left;clear: both;" [items]="status_types" bindLabel="text"
                        placeholder="Durum.." formControlName="status">
                    </ng-select>
                    <small class="form-text text-warning" *ngIf="f.status.errors?.required">Lütfen durum seçiniz!</small>
                </div>  

                <div class="form-group">
                    <label for="eventCategoryId" class="col-form-label">Etkinlik Kategorisi</label>
                    <ng-select name="eventCategoryId" id="eventCategoryId" labelForId="eventCategoryId"
                        bindValue="id" style="width: 100%; padding: 5px; float: left;clear: both;" placeholder="Etkinlik kategorisi" [items]="eventCategories"
                        bindLabel="name" formControlName="eventCategoryId">
                    </ng-select>
                </div>

                <div class="form-group">
                    <label for="startDate" class="col-form-label">Başlangıç tarihi</label>
                    <input class="form-control" type="date" id="startDate"
                        formControlName="startDate" placeholder="Başlangıç tarihi" name="startDate">
                    <small class="form-text text-warning" *ngIf="f.startDate.errors?.required">Lütfen etkinlik başlangıç
                        tarihinizi giriniz!</small>
                </div>

                <div class="form-group">
                    <label for="endDate" class="col-form-label">Bitiş tarihi</label>
                    <input class="form-control" type="date" id="endDate"
                        formControlName="endDate" placeholder="Bitiş tarihi" name="endDate">
                    <small class="form-text text-warning" *ngIf="f.endDate.errors?.required">Lütfen etkinlik bitiş
                        tarihinizi giriniz!</small>
                </div>

                <div class="form-group">
                    <label class="col-form-label">Etkinlik resmi</label>
                    <ngx-file-drop dropZoneLabel="Dosyaları buraya sürükleyin" style="width: 100%;"
                        (onFileDrop)="onLocalFileChange($event)"
                        dropZoneClassName="custom-dropzone">
                        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                            Dosyayı buraya sürükle veya
                            <button type="button" class="btn btn-outline-info ml-3"
                                (click)="openFileSelector()">Dosya
                                seç</button>
                        </ng-template>
                    </ngx-file-drop>
                    <ng-container *ngIf="event.image">
                        <div class="files-container">
                            <div class="file-container">
                                <img class="file-image"
                                    [src]="assetsPath + event.image">
                                    <a href="{{assetsPath + event.image}}" target="_blank"><span class="file-name">{{event.image}}</span></a>
                                <button class="btn btn-danger btn-sm"
                                    (click)="removeFile()"><i class="fa fa-trash"></i>
                                    Kaldır</button>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <div class="form-group">
                    <label for="applicationEndDate" class="col-form-label">Son başvuru tarihi</label>
                    <input class="form-control" type="date" id="applicationEndDate"
                        formControlName="applicationEndDate" placeholder="Son başvuru tarihi" name="endDate">
                    <small class="form-text text-warning" *ngIf="f.applicationEndDate.errors?.required">Lütfen etkinlik son başvuru
                        tarihinizi giriniz!</small>
                </div>

                <div class="form-group">
                    <label class="kt-checkbox w-100">
                        <input type="checkbox" name="isAvailableAllUser" class="form-control" formControlName="isAvailableAllUser" [(ngModel)]="event.isAvailableAllUser">
                        Bütün gönüllülere açık mı?
                        <span></span>
                    </label>
                </div>
            </div>
            <div class="kt-portlet__foot">
                <div class="kt-form__actions">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-success" (click)="save()">Kaydet</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>